export default "__VITE_ASSET__SZxtBflR__"